// Features: M004-F0716
// Tests: T-M004-0212 (phase B)
//
// One inline stage sentence (and Core's next action, verbatim) from inlineStage(). Failure stages use the existing problem style.
import React from 'react';
import { inlineStage } from './stageInline';

export default function StageLine({ stage, detail, reason, nextAction, handOffId }) {
  const view = inlineStage({ stage, detail, reason, nextAction, handOffId });
  if (!view) return null;
  return <span className={view.problem ? 'ledger-queue-stage pill-problem-text' : 'ledger-queue-stage ledger-queue-muted'} data-testid="tx-stage-inline" data-stage={view.stage}>
    {' · '}{view.text}
    {view.nextAction ? <span data-testid={view.nextMissing ? 'tx-next-missing' : 'tx-next-action'}> {view.nextAction}</span> : null}
  </span>;
}
